import { render } from "./Approval.vue?vue&type=template&id=08895a39"
import script from "./Approval.vue?vue&type=script&lang=js"
export * from "./Approval.vue?vue&type=script&lang=js"

import exportComponent from "/home/astaguna/Documents/dct/transferapproval/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__